var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "reservation-list" } }, [
    _c("div", { staticClass: "calendar-actions" }, [
      _c(
        "div",
        {
          staticClass: "my-calendars-title",
          on: {
            click: function () {
              return (_vm.calendarListVisible = !_vm.calendarListVisible)
            },
          },
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("calendar.reservations"))),
          ]),
          _vm._v(" "),
          _vm.calendarListVisible
            ? _c("span", { staticClass: "material-icons" }, [
                _vm._v("expand_less"),
              ])
            : _c("span", { staticClass: "material-icons" }, [
                _vm._v("expand_more"),
              ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.calendarListVisible
      ? _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.reservationList, function (reservation) {
            return _c("div", { staticClass: "item" }, [
              _c(
                "span",
                {
                  staticClass: "name",
                  on: {
                    click: function ($event) {
                      return _vm.$router.replace(
                        "/reservation/" + reservation._id
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(reservation.title))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "material-icons delete",
                  on: {
                    click: function ($event) {
                      return _vm.deleteReservationPlan(reservation._id)
                    },
                  },
                },
                [_vm._v("close")]
              ),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }